import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import AccountsLinkedAccountsCard from 'tio-employee/components/accounts/linked-accounts-card';
import RecommendationsDashRecommendations from 'tio-employee/components/recommendations/dash-recommendations';
import IdrDashboard0726PreviousResults from 'tio-employee/components/idr-dashboard-0726/previous-results';
import IdrDashboard0726WhatHappensNext from 'tio-employee/components/idr-dashboard-0726/what-happens-next';
import IdrDashboard0726UsageHistory from 'tio-employee/components/idr-dashboard-0726/usage-history';
import Button from 'tio-ui/components/button';
import { HStack, Section, VStack } from 'tio-ui/components/layout';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: EmployeeModel;
  };
}

const tmpl: TOC<S> = <template>
  <HStack>
    <VStack>
      <AccountsLinkedAccountsCard
        @accounts={{@model.accounts}}
        {{! @glint-expect-error: matches the existing IDR dashboard usage}}
        @loanSummary={{@model.loanSummary}}
        @person={{@model.person}}
        @programName={{t "dashboard_tiles.income_driven_repayment"}}
        @source="idr"
        @providers="nslds"
      />
      <RecommendationsDashRecommendations
        class="grow"
        {{! @glint-expect-error: matches the existing IDR dashboard usage}}
        @loanSummary={{@model.loanSummary}}
        @person={{@model.person}}
        {{! @glint-expect-error: matches the existing IDR dashboard usage}}
        @recommendation={{@model.mostRecentRecommendation}}
        @source="idr"
        @hideConsolidation={{true}}
      />
    </VStack>
  </HStack>
  {{! First-run CTA: shown only until the user has an IDR-0726 result. After
      that, re-running happens via the "What happens next?" card below. }}
  {{! @glint-expect-error: relationship typing on the model}}
  {{#unless @model.mostRecentRecommendation}}
    <Section>
      <:header>{{t "idr_dashboard_0726.title"}}</:header>
      <:body>
        <p class="text-sm mb-4">{{t "idr_dashboard_0726.subtitle"}}</p>
        <Button
          @intent="primary"
          {{on "click" (transitionTo "authenticated.idr.dashboard.questionnaire")}}
        >
          {{t "idr_dashboard_0726.start"}}
        </Button>
      </:body>
    </Section>
  {{/unless}}

  {{! When there are past runs: show the last run's comparison ("Previous
      Results"), then "What happens next?", then the full history table. }}
  {{! @glint-expect-error: relationship typing on the model}}
  {{#if @model.mostRecentRecommendation}}
    {{! @glint-expect-error: relationship typing on the model}}
    <IdrDashboard0726PreviousResults @recommendation={{@model.mostRecentRecommendation}} />
    <IdrDashboard0726WhatHappensNext />
  {{/if}}

  {{! IDR Recommendation History — each run links to its own results page. }}
  {{! @glint-expect-error: relationship typing on the model}}
  {{#if @model.history.length}}
    {{! @glint-expect-error: relationship typing on the model}}
    <IdrDashboard0726UsageHistory @recommendations={{@model.history}} />
  {{/if}}
</template>;

export default tmpl;
